import { IConsumableDetails } from "@Models/IConsumableDetails";
import ConsumablesService from "@Services/ConsumablesService";
import { useMutation } from "@tanstack/react-query";
import { IConsumableEditFormValues } from "./types";

export const useDeleteConsumable = () => {
  const service = new ConsumablesService();

  return useMutation(async (id: string) => await service.delete(id));
};

export const useUpdateConsumableImage = () => {
  const service = new ConsumablesService();

  return useMutation(
    async ({
      consumableId,
      imageUrl,
    }: {
      consumableId: string;
      imageUrl: IConsumableEditFormValues["imageUrl"][0];
    }) => {
      const formData = new FormData();
      formData.append("image", imageUrl.originFileObj);
      return await service.updateImage(consumableId, formData);
    }
  );
};

export const useCreateConsumable = () => {
  const service = new ConsumablesService();

  const { mutateAsync: updateConsumableImage } = useUpdateConsumableImage();

  return useMutation(async (values: IConsumableEditFormValues) => {
    const { imageUrl, ...rest } = values;

    const data: Omit<IConsumableDetails, "imageUrl"> = {
      ...rest,
      description: values.description ?? "",
      productIds: values.productIds.map((item) => ({ id: item })),
    };

    return await service.create(data).then(async (res) => {
      if (!res.hasErrors && res.value.id && !!values?.imageUrl?.length) {
        return await updateConsumableImage({ consumableId: res.value.id, imageUrl: imageUrl[0] });
      } else {
        return res;
      }
    });
  });
};

export const useUpdateConsumable = (consumableId: string) => {
  const service = new ConsumablesService();

  const { mutateAsync: updateConsumableImage } = useUpdateConsumableImage();

  return useMutation(async (values: IConsumableEditFormValues) => {
    const { imageUrl, ...rest } = values;

    const data: Omit<IConsumableDetails, "imageUrl"> = {
      ...rest,
      consumableId,
      productIds: values.productIds.map((item) => ({ id: item })),
    };

    return await service.update(data).then(async (res) => {
      if (!res.hasErrors && !!values?.imageUrl?.length) {
        return await updateConsumableImage({ consumableId, imageUrl: imageUrl[0] });
      } else {
        return res;
      }
    });
  });
};
